import React from 'react';
import FontIcon from 'material-ui/FontIcon';

const SearchResultsList = ({image, name, artists, previewUrl, duration, id, onPlayTrack, playing, isPlaying}) => {
  return (
    <li className={`search-result ${playing === id ? 'search-result__highlight' : ''}`} onClick={() => onPlayTrack(previewUrl, name, artists, id, image, duration, playing === id)} >
      <div className="search-result--container" >
        <img className="search-result--image" src={image} alt={name} />
        <div className="search-result--info" >
          <h2>{name}</h2>
          <p>{artists}</p>
        </div>
      </div>
      <div className="search-result--icon" >
          {
            playing === id && isPlaying 
            ? <FontIcon color="#fff" className="material-icons">pause_circle_filled</FontIcon> 
            : playing === id
              ? <FontIcon color="#fff" className="material-icons">play_circle_filled</FontIcon> 
              : null
          }
      </div>
    </li>
  )
}

export default SearchResultsList;


// WEBPACK FOOTER //
// ./src/components/SearchResultsList.jsx